import { render, staticRenderFns } from "./faqWebsite.vue?vue&type=template&id=7f4cddea&scoped=true"
import script from "./faqWebsite.vue?vue&type=script&lang=js"
export * from "./faqWebsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cddea",
  null
  
)

export default component.exports